import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { Angulartics2Module } from 'angulartics2';

import { FormValidationModule } from '@tablesready/common-ui';
import { AlertsSettingsComponent } from './alerts-settings.component';
import { AlertsSettingsRoutingModule } from './alerts-settings.routing.module';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [AlertsSettingsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AuthModule,
    AlertsModule,
    FormValidationModule,
    Angulartics2Module,
    AlertsSettingsRoutingModule,
    FrontendPullRefreshModule,
  ],
})
export class AlertsSettingsModule {}
